import { API_URL } from '../constants'
import { axiosInstance } from './axiosinstance'

const COURSES_API_URL = `${API_URL}/api/v1/courses`

export const clearCourseCache = async () => {
  try {
    const response = await axiosInstance.put(`${COURSES_API_URL}/clear_cache`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.status === 200) {
      console.log('Course cache cleared successfully')
    }

    return true
  } catch (error) {
    console.error('Error clearing course cache:', error)
    return false
  }
}

export const loadCourseData = async () => {
  try {
    const response = await axiosInstance.get(COURSES_API_URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.status != 200) {
      console.warn(
        `WARN: Couldn't load course data from LMS: '${response.status}':'${response.statusText}'`
      )
      return []
    }

    const json = await response.data

    return json
  } catch (error) {
    console.warn(
      "WARN: Couldn't load course data from LMS: '" + error.message + "'"
    )
    return []
  }
}

const ACTIVE_ILT_URL = `${COURSES_API_URL}/active_ilt`

export const fetchActiveIltCatalogue = async (): Promise<string | null> => {
  try {
    console.log('[fetchActiveIltCatalogue] requesting:', ACTIVE_ILT_URL)
    const response = await axiosInstance.get(ACTIVE_ILT_URL)
    console.log('[fetchActiveIltCatalogue] status:', response.status, 'data:', response.data)
    if (response.status !== 200) return null
    const data = response.data
    const item = Array.isArray(data) ? data[0] : data
    const url = item?.file_link || item?.file_url || null
    console.log('[fetchActiveIltCatalogue] resolved url:', url)
    return url
  } catch (error) {
    console.warn('[fetchActiveIltCatalogue] error:', error.message, error)
    return null
  }
}

export const loadSelfPacedCourses = async () => {
  try {
    const response = await axiosInstance.get(
      `${COURSES_API_URL}?course_type=olt`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (response.status != 200) {
      console.warn(
        `WARN: Couldn't load course data from LMS: '${response.status}':'${response.statusText}'`
      )
      return []
    }

    const json = await response.data
    return json
  } catch (error) {
    console.log(error)
    console.warn(
      "WARN: Couldn't load course data from LMS: '" + error.message + "'"
    )
    return []
  }
}